import React, { useState, useEffect, useContext } from 'react';

/** context */
import { UserContext } from '../../context/UserContext';
import { validateInputField } from '../../helpers/validation';

const fields = [
  {
    label: 'First Name',
    name: 'firstName',
    limits: { minimum: 2, maximum: 100 },
    order: 1,
    type: 'text',
    required: true,
  },
  {
    label: 'Last Name',
    name: 'lastName',
    limits: { minimum: 2, maximum: 100 },
    order: 2,
    type: 'text',
    required: true,
  },
  {
    label: 'Email',
    limits: { minimum: 6, maximum: 60 },
    name: 'email',
    order: 3,
    pattern:
      '(?:[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*|"(?:[\\x01-\\x08\\x0b\\x0c\\x0e-\\x1f\\x21\\x23-\\x5b\\x5d-\\x7f]|\\\\[\\x01-\\x09\\x0b\\x0c\\x0e-\\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\\x01-\\x08\\x0b\\x0c\\x0e-\\x1f\\x21-\\x5a\\x53-\\x7f]|\\\\[\\x01-\\x09\\x0b\\x0c\\x0e-\\x7f])+)\\])',
    type: 'email',
    required: true,
  },
  {
    label: 'Address',
    limits: { minimum: 5, maximum: 100 },
    name: 'address',
    order: 4,
    pattern: '^(?i)(?!p\\.?o\\.?\\sbox|post\\soffice).*$',
    type: 'address',
    required: true,
  },
];

export default function BnplDetails({
  className,
  gotoNextStep,
  renderField,
  data,
  setDataError,
  sectionError,
  setSectionError,
}) {
  const handleSubmit = async () => {
    const result = fields.map((field) => {
      return validateInputField(data[field.name], field.name, field, setDataError);
    });

    const isInValid = result.filter((r) => !r).length > 0;

    isInValid
      ? setSectionError('Please make sure all fields are filled in correctly.')
      : setSectionError('');

    if (isInValid) {
      return false;
    }

    gotoNextStep();
  };

  return (
    <>
      {sectionError && <p className="section-error">{sectionError}</p>}
      <div className={className}>
        <div className={`${className}__title`}>
          <h1>Welcome</h1>
          <p>Please complete information below to begin your Lendistry Interactive application.</p>
        </div>
        {fields
          .sort((field1, field2) => field1.order - field2.order)
          .map((field) => renderField(field))}
        <div className={`${className}__button-container margin-top-32`}>
          <button type="submit" onClick={handleSubmit}>
            Next
          </button>
        </div>
      </div>
    </>
  );
}
